// Cache key constants
export const TOKEN_KEY = 'token';
export const USER_DATA_KEY = 'userData';
export const LAST_FETCHED_KEY = 'lastFetched';
export const WHATSAPP_SETUP = 'whatsapp_setup';
export const PHONE_NUMBER_ID = 'phoneNumberId';

export const CURRENT_WORKSPACE_KEY = 'current_workspace';

// Time constants
export const THIRTY_MINUTES = 30 * 60 * 1000; // 30 minutes in milliseconds
